/* eslint-disable max-len */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Row,
    Col,
    Divider,
    Button,
    Form,
    Input,
    Radio,
    Checkbox,
} from 'antd';
import MUIFormItem from '@/components/MUIFormItem';
import { PlusIcon, DeleteIcon } from '@/assets/images/icons/screens';

const RoomPolicy = ({
    currency,
    validations,
    setIsRefundable,
    isRefundable,
}) => {
    const { t } = useTranslation();

    const options = useMemo(() => ([
        { label: t('%'), value: 4 },
        { label: t(currency), value: 5 },
    ]), [t]);

    return (
        <Row gutter={[28, 0]}>
            <Col xxl={9} xs={24}>
                <MUIFormItem
                    label={t('Minimum Stay: X Days Required')}
                    name="minimum_stay_required"
                >
                    <Input
                        placeholder={t('Number of days')}
                        type="number"
                        min={0}
                        max={100}
                        step={1}
                    />
                </MUIFormItem>
            </Col>
            <Col xxl={9} xs={24}>
                <div className="refundable-amount-wrapper">
                    <MUIFormItem
                        label={t('Prepayment Amount')}
                        name="prepayment_amount"
                    >
                        <Input
                            suffix={(
                                <>
                                    0.00
                                    <Form.Item
                                        name="prepayment_amount_type"
                                        noStyle
                                    >
                                        <Radio.Group
                                            options={options}
                                            optionType="button"
                                            buttonStyle="solid"
                                        />
                                    </Form.Item>
                                </>
                            )}
                        />
                    </MUIFormItem>
                </div>
            </Col>
            <Col xxl={6} xs={24}>
                <Form.Item
                    name="is_refundable"
                    valuePropName="checked"
                >
                    <Checkbox onClick={() => setIsRefundable(!isRefundable)}>
                        {t('Is Refundable')}
                    </Checkbox>
                </Form.Item>
            </Col>
            {isRefundable && (
                <Col xxl={8} xs={24}>
                    <div className="refundable-amount-wrapper">
                        <MUIFormItem
                            label={t('Refundable Amount')}
                            name="refundable_amount"
                        >
                            <Input
                                suffix={(
                                    <>
                                        0.00
                                        <Form.Item
                                            name="refundable_amount_type"
                                            noStyle
                                        >
                                            <Radio.Group
                                                options={options}
                                                optionType="button"
                                                buttonStyle="solid"
                                            />
                                        </Form.Item>
                                    </>
                                )}
                            />
                        </MUIFormItem>
                    </div>
                </Col>
            )}
            <Col xxl={10} sm={24} xs={24}>
                <MUIFormItem
                    label={t('Total Payment Required X Days Before Check-In')}
                    name="total_payment_required_before_check_in"
                >
                    <Input
                        placeholder={t('Number of days')}
                        type="number"
                        min={0}
                        max={100}
                        step={1}
                    />
                </MUIFormItem>
            </Col>
            <Col xs={24}>
                <Form.List name="refundable_cancellation">
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map((field) => (
                                <div key={field.key} className="refundable-cancellation-item">
                                    <Row gutter={30}>
                                        <Col xxl={5} sm={12} xs={24}>
                                            <MUIFormItem
                                                label={t('From Day')}
                                                name={[field.name, 'from']}
                                                formListName="refundable_cancellation"
                                            >
                                                <Input
                                                    type="number"
                                                    min={0}
                                                    max={100}
                                                    step={1}
                                                />
                                            </MUIFormItem>
                                        </Col>
                                        <Col xxl={5} sm={12} xs={24}>
                                            <MUIFormItem
                                                label={t('To Day')}
                                                name={[field.name, 'to']}
                                                formListName="refundable_cancellation"
                                            >
                                                <Input
                                                    type="number"
                                                    min={0}
                                                    max={100}
                                                    step={1}
                                                />
                                            </MUIFormItem>
                                        </Col>
                                        <Col xxl={10} sm={18} xs={24}>
                                            <MUIFormItem
                                                label={t('Refundable Amount')}
                                                name={[field.name, 'refundable_amount']}
                                                formListName="refundable_cancellation"
                                            >
                                                <Input
                                                    suffix={(
                                                        <>
                                                            0.00
                                                            <Form.Item
                                                                name={[field.name, 'refundable_amount_type']}
                                                                rules={validations.refundableAmountType}
                                                                noStyle
                                                            >
                                                                <Radio.Group
                                                                    options={options}
                                                                    optionType="button"
                                                                    buttonStyle="solid"
                                                                />
                                                            </Form.Item>
                                                        </>
                                                    )}
                                                />
                                            </MUIFormItem>
                                        </Col>
                                        <Col xxl={4} sm={6} xs={24}>
                                            <Form.Item>
                                                <Button
                                                    className="button btn-grey"
                                                    onClick={() => remove(field.name)}
                                                >
                                                    <DeleteIcon />
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Divider dashed />
                                </div>
                            ))}
                            <Form.Item className="add-button-form">
                                <Row justify="end">
                                    <Col>
                                        <Button
                                            className="button add-button-outlined"
                                            onClick={() => add()}
                                        >
                                            <PlusIcon />
                                            {t('add refundable cancellation policy').toUpperCase()}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form.Item>
                        </>
                    )}
                </Form.List>
            </Col>
        </Row>
    );
};

export default RoomPolicy;
